import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledPremiumContentWarning = styled.div`
  flex: 0.5;
  background-color: ${Colors.backgroundPalerBlueDark};
  border-radius: 10px 10px 0 0;
  border: 1px solid ${Colors.darkBlue}11;
  border-bottom: none;
  padding: 20px 40px 10px;
  line-height: 30px;
  font-size: 16px;

  .text {
    .sign-up-button {
      margin-right: 5px;
    }
    .log-in-button {
      margin-right: 5px;
      margin-left: 5px;
    }

    .link {
      cursor: pointer;
      color: ${Colors.primary};
      font-weight: bold;
    }
  }
`;
